import * as React from 'react';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import _ from 'lodash';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  DialogActions,
  Typography,
  FormControlLabel,
  Switch,
  ButtonGroup
} from '@material-ui/core';
import Download from '@jda/lui-common-icon-library/ui/Download';
import { NetworkStatus } from '@apollo/client';
import ERROR_DIAGNOSIS_QUERY, {
  AUDIT_HISTORY,
  ERROR_DIAGNOSIS_QUERY_FREIGHT_TRACKING,
  ERROR_DIAGNOSIS_QUERY_FT_EVENTS,
  REPLAY_QUERY,
  USER_DETAILS,
  WORKFLOW_QUERY,
  GET_CONFIGURATION_SETTINGS
} from '../graphQL/queries';
import { Loading } from '../../Loading';
import { getColumns, subcolumns } from '../../utils/columns';
import { DispatchContext, StateContext } from '../../App';
import { useStyles } from './style';
import ErrorDiagnosis from '../../components/ErrorDiagnosis/index';
import CustomGrid from '../../components/CustomGrid';
import { filterFields, getUTCDate, mapSearchFields } from '../../utils/globalUtils';
import { Refresh } from '@material-ui/icons';
import { Filter, FilterOff } from '@jda/lui-common-icon-library';
import Settings from '@jda/lui-common-icon-library/ui/Settings';
import ViewDetails from '@jda/lui-common-icon-library/ui/ViewDetails';
import { archiveDataConfig, filterDataConfig, freightFilterDataConfig } from './filterFields';
import { responseTimeData } from '../ErrorDiagnosis/filterFields';
import JsonEditor from '../../components/JsonEditor';
import { formatString } from '../../utils/helpers';

interface ErrorDiagnosisProps {
  isParticipantLevel?: any;
  isServiceLevel?: any;
  workflowCode?: any;
  participant?: any;
  isAdminLevel?: any;
  id?: any;
  history?: any;
  search?: any;
}

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};
type workflowContentData = {
  content: workflowInfo[];
};

const retryStatusData = [
  {
    id: 1,
    value: 'SCHEDULED'
  },
  {
    id: 2,
    value: 'INPROGRESS'
  },
  {
    id: 3,
    value: 'COMPLETED'
  }
];

const ErrorDiagnosiss = (props: ErrorDiagnosisProps) => {
  let participantType =
    props?.participant?.participantType === undefined ? 'ADMIN' : props?.participant?.participantType;

  let configuration_key = '';
  if (participantType && props?.workflowCode) {
    configuration_key = participantType + '-' + props.workflowCode;
  } else if (participantType === 'CUSTOMER' || participantType === 'PROVIDER') {
    configuration_key = participantType + '-' + 'global';
  } else if (participantType === 'ADMIN') {
    configuration_key = 'global-global';
  }
  const { loading: userLoading, data: userData, refetch: userRefetch } = useQuery(USER_DETAILS, {});

  const { loading: configurationLoading, data: configurationData, refetch: configurationRefetch } = useQuery(
    GET_CONFIGURATION_SETTINGS,
    {
      variables: { applicationId: 'BYN-SelfService', keys: [configuration_key + '-error-diagnosis'] }
    }
  );
  const dispatch = React.useContext(DispatchContext);
  const state = React.useContext(StateContext);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [replayInfo] = useMutation(REPLAY_QUERY);
  const { data: workflowList } = useQuery(WORKFLOW_QUERY, {});
  const date_format: string = 'YYYY-MM-DD H:mm:ss';
  const [workflowCode, setWorkflowCode] = React.useState(props?.workflowCode ? props.workflowCode : '');
  const defaultFilter: any = {
    retryStatus: '',
    requestType: [],
    operations: [],
    loadIds: [],
    providerLoadIds: [],
    customerCodes: [],
    providerCodes: [],
    responseStatus: [],
    providerCustomerCodes: [],
    statusCodes: [],
    aggregator: [],
    customerAggregator: [],
    service: props?.isAdminLevel ? [] : [workflowCode !== 'freightTracking' ? workflowCode : ''],
    id: [],
    shipmentId: [],
    lmd: [],
    partnerName: [],
    ingestionId: [],
    timeTaken: {
      symbol: '<',
      value: ''
    },
    createdTimeRange: {
      begin: moment(new Date())
        .subtract(1, 'months')
        .format('YYYY-MM-DD H:mm'),
      end: null
    },
    targetOperation: [],
    targetService: [],
    receiverCode: [],
    apiResponseTime: [],
    initialResponseHttpStatus: {
      fromErrorCode: null,
      toErrorCode: null
    },
    responseHttpStatus: {
      fromErrorCode: null,
      toErrorCode: null
    },
    retryCount: {
      symbol: '<',
      value: ''
    }
  };

  const freightDefaultFilter: any = {
    createdTimeRange: {
      begin: moment(new Date())
        .subtract(1, 'months')
        .format('YYYY-MM-DD H:mm'),
      end: null
    },
    id: [],
    shipmentId: [],
    partnerName: [],
    ingestionId: []
  };

  const [errorColumns, setErrorCoulumns] = React.useState<any>([]);
  const [archiveColumn, setArchiveColumn] = React.useState<any>([]);
  const [sortOrder, setSortOrder] = React.useState<any>('DESC');
  const [sortColumn, setSortColumn] = React.useState<any>('createdTime');
  const [dataType, setDataType] = React.useState<any>('live');
  const [gotoPageNum, setGotoPageNum] = React.useState<any>();
  const [isGoTo, setIsGoTo] = React.useState(false);
  const [pageNumber, setPageNumber] = React.useState<any>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<any>(10);
  const [showErrors, isShowErrors] = React.useState(false);
  const [eventDetails, showEventDetails] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [appliedFilter, setAppliedFilter] = React.useState(false);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [userRole, setUserRole] = React.useState('');
  const [selectedKey, setSelectedKey] = React.useState<any>('SHIPMENTS');
  const [eventId, setEventId] = React.useState<any>([]);
  const [downloadJSONData, setDownloadJSONData] = React.useState(false);
  const [openColumnSelection, setOpenColumnSelection] = React.useState(false);
  const [sortUserPrefs, setSortUserPrefs] = React.useState<any>([]);
  const [appliedColumn, setAppliedColumn] = React.useState<any>([]);
  const [appliedSelection, setAppliedSelection] = React.useState(false);
  const [duration, setDuration] = React.useState<any>(props?.workflowCode === 'freightTracking' ? '1 Day' : '1 Week');
  const [userColumns, setUserCoulumns] = React.useState<any>([]);
  const [userSelPrefsColumns, setUserSelPrefsCoulumns] = React.useState<any>([]);
  const [userPrefsColumns, setUserPrefsCoulumns] = React.useState<any>([]);
  const [searchFilter, setSearch] = React.useState(
    workflowCode === 'freightTracking' ? { ...freightDefaultFilter } : { ...defaultFilter }
  );
  const [enableLoader, setEnableLoader] = React.useState(false);
  const [request, setRequest] = React.useState({});
  const [showEventMessage, setShowEventMessage] = React.useState(false);
  const [auditDetails, showAuditDetails] = React.useState(false);
  const [auditFormData, setAuditFormData] = React.useState({});
  const [enableFreightWorkFlow, setEnableFreightWorkFlow] = React.useState(
    props?.workflowCode === 'freightTracking' ? true : false
  );

  React.useEffect(() => {
    if (configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs) {
      setSortOrder(configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs?.sortOrder || 'DESC');
      setSortColumn(
        configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs?.sortColumn || 'createdTime'
      );
      setDuration(configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs?.duration || '1 Week');
      setRowsPerPage(configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs?.pageNumber || 10);
    }
    setUserRole(userData?.userProfile?.roles?.[0]);
  }, [userData, configurationData]);
  const ErrorDiagnosisActions: any = [
    props.isParticipantLevel && {
      icon: () => (
        <FormControlLabel
          control={<Switch color="primary" checked={enableFreightWorkFlow} />}
          label="Freight Tracking"
          onChange={handleEnableFreightWorkFlow}
        />
      ),
      isFreeAction: true,
      onClick: () => {}
    },
    workflowCode !== 'freightTracking' && {
      icon: () => (
        <FormControlLabel
          control={<Switch color="primary" checked={showErrors} />}
          label="Errors Only"
          onChange={handleErrorToggleChange}
        />
      ),
      isFreeAction: true,
      onClick: () => {}
    },
    {
      icon: () => <Refresh />,
      isFreeAction: true,
      onClick: () => handleRefresh(),
      tooltip: 'Refresh'
    },
    {
      icon: () => <Filter className={appliedFilter ? classes.highlight : ''} />,
      isFreeAction: true,
      onClick: () => toggleFilter(),
      tooltip: 'Apply Filter'
    },
    {
      icon: () => <FilterOff />,
      isFreeAction: true,
      onClick: () => handleReset(),
      tooltip: 'Reset Filter'
    },
    workflowCode !== 'freightTracking' && {
      icon: () => <ViewDetails />,
      onClick: (event: any, rowData: any) => handleViewDetails(rowData),
      tooltip: 'View Details',
      position: 'row'
    },
    workflowCode === 'freightTracking' &&
      selectedKey === 'SHIPMENTS' && {
        icon: () => <ViewDetails />,
        onClick: (event: any, rowData: any) => handleAuditDetails(rowData),
        tooltip: 'Audit History',
        position: 'row'
      },
    workflowCode === 'freightTracking' &&
      selectedKey === 'EVENTS' && {
        icon: () => <ViewDetails />,
        onClick: (event: any, rowData: any) => {
          if (getJSONStatus(rowData.eventMessage)) {
            return handleSpecClick(
              rowData.eventMessage && !_.isEmpty(rowData.eventMessage) ? rowData.eventMessage : {}
            );
          }
        },
        tooltip: 'Audit History',
        position: 'row'
      },
    workflowCode !== 'freightTracking' && {
      icon: () => <Download />,
      onClick: (event: any, rowData: any) => handleDownload(rowData),
      tooltip: 'Download the Input and Output',
      position: 'row'
    },
    workflowCode !== 'freightTracking' && {
      icon: () => (
        <Button
          data-id="Replay-Button"
          id="Replay-Button"
          disableElevation
          variant="outlined"
          color="primary"
          onClick={handleReplay}
        >
          Replay
        </Button>
      ),
      position: 'toolbarOnSelect'
    },
    {
      icon: () => <Settings />,
      isFreeAction: true,
      onClick: () => handleColumnSelection(),
      tooltip: 'Columns Selection'
    },
    workflowCode !== 'freightTracking' && {
      icon: () => (
        <ButtonGroup size="small" aria-label="outlined primary button group">
          <Button
            data-id="live-ErrorTab"
            onClick={() => handleDataTypeChange('live')}
            variant={dataType === 'live' ? 'contained' : 'outlined'}
            color="primary"
          >
            Live
          </Button>
          <Button
            data-id="Archive-ErrorTab"
            onClick={() => handleDataTypeChange('archive')}
            variant={dataType === 'archive' ? 'contained' : 'outlined'}
            color="primary"
          >
            Archive
          </Button>
        </ButtonGroup>
      ),
      isFreeAction: true,
      onClick: () => {}
    },
    workflowCode === 'freightTracking' && {
      icon: () => (
        <ButtonGroup size="small" aria-label="outlined primary button group">
          <Button
            data-id="Events-ErrorTab"
            onClick={() => handleNotificationTabs('EVENTS')}
            variant={selectedKey === 'EVENTS' ? 'contained' : 'outlined'}
            color="primary"
          >
            Events
          </Button>
          <Button
            data-id="Shipments-ErrorTab"
            onClick={() => handleNotificationTabs('SHIPMENTS')}
            variant={selectedKey === 'SHIPMENTS' ? 'contained' : 'outlined'}
            color="primary"
          >
            Entities
          </Button>
        </ButtonGroup>
      ),
      isFreeAction: true,
      onClick: () => {}
    }
  ];

  const jsonRequestEditorRef = React.useRef<any>();
  React.useEffect(() => {
    if (jsonRequestEditorRef && jsonRequestEditorRef.current) {
      jsonRequestEditorRef.current.set(request);
      jsonRequestEditorRef.current.expandAll && jsonRequestEditorRef.current.expandAll();
    }
  }, [request]);

  const setRequestEditorRef = (instance: any) => {
    if (instance) {
      jsonRequestEditorRef.current = instance.jsonEditor;
    } else {
      jsonRequestEditorRef.current = null;
    }
  };

  const getJSONStatus = (rowData: any) => {
    try {
      formatString(rowData);
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleSpecClick = (specData: any) => {
    const specJSON = formatString(specData);
    setRequest(specJSON);
    setShowEventMessage(true);
  };

  const handleEventDialogClose = () => {
    setShowEventMessage(false);
    setRequest({});
  };

  const setFilter = () => {
    if (window.location.search.includes('customerCode')) {
      const customerCode = getQueryVariable('customerCode')?.split(':');
      if (customerCode?.length) defaultFilter.customerCodes.push(...customerCode);
    }
    if (window.location.search.includes('operation')) {
      const operatiocode = getQueryVariable('operation')?.split(':');
      if (operatiocode?.length) defaultFilter.operations.push(...operatiocode);
    }
    if (window.location.search.includes('uniqueCustomerTransactionId')) {
      const uniqueCustomerTransactionId = getQueryVariable('uniqueCustomerTransactionId')?.split(':');
      if (uniqueCustomerTransactionId?.length) defaultFilter.loadIds.push(...uniqueCustomerTransactionId);
    }
    if (window.location.search.includes('uniqueProviderTransactionId')) {
      const uniqueProviderTransactionId = getQueryVariable('uniqueProviderTransactionId')?.split(':');
      if (uniqueProviderTransactionId?.length) defaultFilter.providerLoadIds.push(...uniqueProviderTransactionId);
    }
    if (window.location.search.includes('providerCode')) {
      const providerCode = getQueryVariable('providerCode')?.split(':');
      if (providerCode?.length) defaultFilter.providerCodes.push(...providerCode);
    }
    if (window.location.search.includes('providerCustomerCode')) {
      const providerCustomerCode = getQueryVariable('providerCustomerCode')?.split(':');
      if (providerCustomerCode?.length) defaultFilter.providerCustomerCodes.push(...providerCustomerCode);
    }
    if (window.location.search.includes('statusCode')) {
      const statusCode = getQueryVariable('statusCode')?.split(':');
      if (statusCode?.length) defaultFilter.statusCodes.push(...statusCode);
    }
    if (window.location.search.includes('responseStatus')) {
      const responseStatus = getQueryVariable('responseStatus')?.split(':');
      if (responseStatus?.length) defaultFilter.responseStatus.push(...responseStatus);
    }
    if (window.location.search.includes('customerAggregator')) {
      const customerAggregator = getQueryVariable('customerAggregator')?.split(':');
      if (customerAggregator?.length) defaultFilter.aggregator.push(...customerAggregator);
    }
    if (window.location.search.includes('aggregatorCode')) {
      const aggregatorCode = getQueryVariable('aggregatorCode')?.split(':');
      if (aggregatorCode?.length) defaultFilter.aggregator.push(...aggregatorCode);
    }
    if (window.location.search.includes('service')) {
      const service = getQueryVariable('service')?.split(':');
      if (service?.length && service[0] !== '') defaultFilter.service.push(...service);
    }
    if (window.location.search.includes('id')) {
      const id = getQueryVariable('id')?.split(':');
      if (id?.length) {
        if (workflowCode === 'freightTracking') freightDefaultFilter.id.push(...id);
        else defaultFilter.id.push(...id);
      }
    }
    if (window.location.search.includes('shipmentId')) {
      const shipmentId = getQueryVariable('shipmentId')?.split(':');
      if (shipmentId?.length) {
        if (workflowCode === 'freightTracking') freightDefaultFilter.shipmentId.push(...shipmentId);
        else defaultFilter.shipmentId.push(...shipmentId);
      }
    }
    if (window.location.search.includes('lmd')) {
      const lmd = getQueryVariable('lmd')?.split(':');
      if (lmd?.length) defaultFilter.lmd.push(...lmd);
    }
    if (window.location.search.includes('partnerName')) {
      const partnerName = getQueryVariable('partnerName')?.split(':');
      if (partnerName?.length) {
        if (workflowCode === 'freightTracking') freightDefaultFilter.partnerName.push(...partnerName);
        else defaultFilter.partnerName.push(...partnerName);
      }
    }
    if (window.location.search.includes('ingestionId')) {
      const ingestionId = getQueryVariable('ingestionId')?.split(':');
      if (ingestionId?.length) {
        if (workflowCode === 'freightTracking') freightDefaultFilter.ingestionId.push(...ingestionId);
        else defaultFilter.ingestionId.push(...ingestionId);
      }
    }
    if (window.location.search.includes('targetOperation')) {
      const targetOperation = getQueryVariable('targetOperation')?.split(':');
      if (targetOperation?.length) defaultFilter.targetOperation.push(...targetOperation);
    }
    if (window.location.search.includes('targetService')) {
      const targetService = getQueryVariable('targetService')?.split(':');
      if (targetService?.length) defaultFilter.targetService.push(...targetService);
    }
    if (window.location.search.includes('timeTaken')) {
      const timeTaken = getQueryVariable('timeTaken') || '';
      if (timeTaken !== '') {
        let symbol = '<';
        if (timeTaken.includes(encodeURIComponent('<'))) {
          symbol = '<';
        } else {
          symbol = '>';
        }

        const value = timeTaken.split(encodeURIComponent(symbol))[1];
        defaultFilter.timeTaken.symbol = symbol;
        defaultFilter.timeTaken.value = value;
      }
    }
    if (window.location.search.includes('startDate')) {
      const startDate = getQueryVariable('startDate');
      if (startDate?.length) {
        if (workflowCode === 'freightTracking')
          freightDefaultFilter.createdTimeRange.begin = decodeURIComponent(startDate).replace('+', ' ');
        else defaultFilter.createdTimeRange.begin = decodeURIComponent(startDate).replace('+', ' ');
      }
    }
    if (window.location.search.includes('endDate')) {
      const endDate = getQueryVariable('endDate');
      if (endDate?.length) {
        if (workflowCode === 'freightTracking')
          freightDefaultFilter.createdTimeRange.end = decodeURIComponent(endDate).replace('+', ' ');
        else defaultFilter.createdTimeRange.end = decodeURIComponent(endDate).replace('+', ' ');
      }
    }
    if (window.location.search.includes('receiverCode')) {
      const reciever = getQueryVariable('receiverCode')?.split(':');
      if (reciever) defaultFilter.receiverCode.push(...reciever);
    }
    if (window.location.search.includes('apiResponseTime')) {
      const apiResponseTime = getQueryVariable('apiResponseTime')?.split(':');
      if (apiResponseTime?.length) defaultFilter.apiResponseTime.push(...apiResponseTime);
    }
    if (window.location.search.includes('retryCount')) {
      const retryCount = getQueryVariable('retryCount') || '';
      if (retryCount !== '') {
        let symbol = '<';
        if (retryCount.includes(encodeURIComponent('<'))) {
          symbol = '<';
        } else {
          symbol = '>';
        }

        const value = retryCount.split(encodeURIComponent(symbol))[1];
        defaultFilter.retryCount.symbol = symbol;
        defaultFilter.retryCount.value = value;
      }
    }
    if (window.location.search.includes('retryStatus')) {
      const retryStatus = getQueryVariable('retryStatus')?.split(':');
      if (retryStatus?.length) defaultFilter.retryStatus.push(...retryStatus);
    }
    if (window.location.search.includes('initialResponseHttpStatus')) {
      const initialResponseHttpStatus = getQueryVariable('initialResponseHttpStatus')?.split(':') || [];
      if (initialResponseHttpStatus.length > 0) {
        filterDataConfig.forEach((filter: any) => {
          if (filter.id === 'initialResponseHttpStatus') filter.isDefaultExpanded = true;
          return filter;
        });
        defaultFilter.initialResponseHttpStatus.fromErrorCode = initialResponseHttpStatus[0];
        defaultFilter.initialResponseHttpStatus.toErrorCode = initialResponseHttpStatus[1];
      }
    }
    if (window.location.search.includes('responseHttpStatus')) {
      const responseHttpStatus = getQueryVariable('responseHttpStatus')?.split(':') || [];
      if (responseHttpStatus.length > 0) {
        filterDataConfig.forEach((filter: any) => {
          if (filter.id === 'responseHttpStatus') filter.isDefaultExpanded = true;
        });
        defaultFilter.responseHttpStatus.fromErrorCode = responseHttpStatus[0];
        defaultFilter.responseHttpStatus.toErrorCode = responseHttpStatus[1];
      }
    }
  };

  const getQueryVariable = (variable: string) => {
    const query = window.location.search.substring(1).replace('search=', '');
    const params = query.split(',');
    for (let i = 0; i < params.length; i++) {
      let splitType: any = '=';
      if (variable === 'initialResponseHttpStatus' || variable === 'responseHttpStatus') {
        splitType = '!';
      } else if (variable === 'apiResponseTime') {
        splitType = encodeURIComponent('>');
      }
      const pair = params[i].split(splitType);
      if (
        (variable === 'retryCount' && params[i].includes('retryCount')) ||
        (variable === 'timeTaken' && params[i].includes('timeTaken'))
      ) {
        return params[i].split('&')[0];
      } else {
        if (pair[0] === variable) {
          return pair[1].split('&')[0];
        }
      }
    }
    return;
  };

  const isPresent = (key: string) => {
    return (searchFilter && searchFilter[key] && searchFilter[key]?.length > 0) || searchFilter[key]?.value;
  };

  const toColonSperated = (key: string) => {
    if (key === 'retryCount' || key === 'timeTaken') return searchFilter[key];
    else if (key === 'operations' && searchFilter[key])
      return searchFilter[key].map((val: any) => val?.value?.trim()).join(':');
    else return searchFilter[key]?.map((val: string) => val?.trim()).join(':');
  };
  const tableId: any = props.id;
  let search: any = {};
  const date: any = new Date();
  let filterDates: any = {};
  let errorCode: any = '';

  const usePrevious = (value: any) => {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const otherSortPrefs = {
    sortOrder: 'DESC',
    sortColumn: 'createdTime',
    duration: '1 Week',
    pageNumber: 10
  };

  const prevWorkFlowCode = usePrevious(workflowCode);
  React.useEffect(() => {
    if (prevWorkFlowCode !== workflowCode) {
      handleReset();
      setOpenFilter(false);
    }
    if (props.search) {
      let pathName: any;
      isShowErrors(false);
      pathName = props?.history?.location?.pathname;
      setOpenFilter(true);
      setAppliedFilter(true);
      setFilter();
      window.history.replaceState({}, document.title, `${window.location.origin}${pathName}`);
    }
    let columns: any = [];
    let userColumn: any = [];
    const archiveColumn = getColumns(classes, 'ARCHIVE', '', state?.userPreferences?.timeZone || 'UTC');
    setArchiveColumn(archiveColumn);
    if (props?.isParticipantLevel && (workflowCode === undefined || workflowCode === '')) {
      userColumn = configurationData?.configurationSettings?.data?.[0]?.configuration?.columns;
      columns = props.isParticipantLevel
        ? getColumns(classes, 'ADMIN', '', state?.userPreferences?.timeZone || 'UTC')
        : getColumns(classes, props?.participant?.participantType, '', state?.userPreferences?.timeZone || 'UTC');
    } else if (workflowCode) {
      userColumn = configurationData?.configurationSettings?.data?.[0]?.configuration?.columns;
      columns = getColumns(
        classes,
        props?.participant?.participantType,
        workflowCode,
        state?.userPreferences?.timeZone || 'UTC'
      );
    } else {
      userColumn = configurationData?.configurationSettings?.data?.[0]?.configuration?.columns;
      columns = props.isAdminLevel
        ? getColumns(classes, 'ADMIN', '', state?.userPreferences?.timeZone || 'UTC')
        : getColumns(classes, props?.participant?.participantType, '', state?.userPreferences?.timeZone || 'UTC');
    }

    const availList: any = [];
    _.forEach(userColumn || [], (element: any) => {
      _.forEach(columns || [], (obj: any) => {
        if (element.field === obj.field) {
          availList.push(obj);
        }
      });
    });

    const selectedList: any = [];
    _.forEach(columns || [], (element: any) => {
      let match: boolean = false;
      _.forEach(userColumn || columns, (obj: any) => {
        if (element.field === obj.field) {
          match = true;
        }
      });
      if (match === false) {
        selectedList.push(element);
      }
    });
    setUserSelPrefsCoulumns(selectedList);
    setUserPrefsCoulumns(availList);
    setUserCoulumns(userColumn);
    setErrorCoulumns(columns);
    setAppliedColumn(availList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classes, props, props.isAdminLevel, props.participant, workflowCode, state, userData, configurationData]);

  let startDate = moment(new Date())
    .subtract(1, 'week')
    .format('YYYY-MM-DD H:mm');
  let endDate = null;
  filterDates.startDate = getUTCDate(startDate, state);
  if (selectedKey === 'EVENTS' && workflowCode === 'freightTracking') {
    let endDate = moment(filterDates.startDate)
      .subtract(10, 'm')
      .format(date_format);

    filterDates.endDate = filterDates.startDate;
    filterDates.startDate = endDate;
  } else if (endDate) {
    filterDates.endDate = getUTCDate(endDate, state);
  }

  React.useEffect(() => {
    dispatch({
      type: 'userPreferences',
      data: {
        [props.id]: {
          id: props.id,
          rowsPerPage: 10,
          page: 0
        }
      }
    });
  }, []);

  React.useEffect(() => {
    if (state?.userPreferences?.[tableId]) {
      setPageNumber(state?.userPreferences?.[tableId]?.page);
      setRowsPerPage(state?.userPreferences?.[tableId]?.rowsPerPage);
    }
  }, [state]);

  React.useEffect(() => {
    setWorkflowCode(props.workflowCode);
    handleNetworkCalls(dataType, showErrors, props.workflowCode);
  }, [
    pageNumber,
    rowsPerPage,
    gotoPageNum,
    sortOrder,
    sortColumn,
    selectedKey,
    appliedFilter,
    searchFilter,
    props.workflowCode
  ]);

  const buildSearchQuery = () => {
    let responseCode: any = 'responseHttpStatus!200:599';
    if (searchFilter?.responseHttpStatus?.fromErrorCode) {
      responseCode = `responseHttpStatus!${searchFilter?.responseHttpStatus?.fromErrorCode}:${searchFilter?.responseHttpStatus?.toErrorCode}`;
    }
    if (props.isAdminLevel) {
      return responseCode;
    } else {
      let { participantCode, participantType } = props?.participant;
      const serviceCriteria = 'service=' + workflowCode !== undefined && workflowCode !== '' ? workflowCode : '';
      let participantTypeCriteria = '';
      switch (participantType) {
        case 'CUSTOMER':
          participantTypeCriteria = 'customerCode';
          break;
        case 'PROVIDER':
          participantTypeCriteria = 'providerCode';
          break;
        case 'AGGREGATOR':
          participantTypeCriteria = 'aggregatorCode';
          break;
        case 'CUSTOMER_AGGREGATOR':
          participantTypeCriteria = 'customerAggregator';
          break;
      }
      return serviceCriteria + ',' + participantTypeCriteria + '=' + participantCode + ',' + responseCode;
    }
  };

  const buildSearchErrorQuery = () => {
    const errorCriteria = 'responseHttpStatus!500:599';
    errorCode = errorCriteria;
    if (props.isAdminLevel) {
      return errorCriteria;
    } else {
      let { participantCode, participantType } = props?.participant;
      const serviceCriteria = 'service=' + workflowCode !== undefined && workflowCode !== '' ? workflowCode : '';
      let participantTypeCriteria = '';
      switch (participantType) {
        case 'CUSTOMER':
          participantTypeCriteria = 'customerCode';
          break;
        case 'PROVIDER':
          participantTypeCriteria = 'providerCode';
          break;
        case 'AGGREGATOR':
          participantTypeCriteria = 'aggregatorCode';
          break;
        case 'CUSTOMER_AGGREGATOR':
          participantTypeCriteria = 'customerAggregator';
          break;
      }
      return serviceCriteria + ',' + participantTypeCriteria + '=' + participantCode + ',' + errorCriteria;
    }
  };

  const handleReplay = () => {
    replayInfo({
      variables: {
        eventId: eventId
      }
    })
      .then(response1 => {
        refetch();
        enqueueSnackbar('Reprocessed successfully !!', { variant: 'success', preventDuplicate: true });
        return response1;
      })
      .catch(error => {
        enqueueSnackbar('Unable to reprocess', { variant: 'error', preventDuplicate: true });
      });
  };

  const toggleFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handleReset = () => {
    dispatch({
      type: 'userPreferences',
      data: {
        [props.id]: {
          id: props.id,
          rowsPerPage: 10,
          page: 0
        }
      }
    });
    setSearch(workflowCode === 'freightTracking' ? { ...freightDefaultFilter } : { ...defaultFilter });
    setAppliedFilter(false);
  };

  const onRowSelection = (selected: any) => {
    const list = Object.keys(selected)
      .map(key => {
        return selected[key]?.eventId;
      })
      .join(',');
    setEventId(list);
  };

  React.useEffect(() => {
    if (duration === '1 Day' && appliedFilter !== true) {
      searchFilter.createdTimeRange.begin = moment(date)
        .subtract(1, 'day')
        .format('YYYY-MM-DD H:mm');
    } else if (duration === '1 Week' && appliedFilter !== true) {
      searchFilter.createdTimeRange.begin = moment(date)
        .subtract(1, 'week')
        .format('YYYY-MM-DD H:mm');
    } else if (duration === '15 Days' && appliedFilter !== true) {
      searchFilter.createdTimeRange.begin = moment(date)
        .subtract(15, 'days')
        .format('YYYY-MM-DD H:mm');
    } else if (duration === '30 Days' && appliedFilter !== true) {
      searchFilter.createdTimeRange.begin = moment(date)
        .subtract(1, 'month')
        .format('YYYY-MM-DD H:mm');
    }
  }, [appliedFilter]);

  // if (duration === '1 Day' && appliedFilter !== true) {
  //   searchFilter.createdTimeRange.begin = moment(date)
  //     .subtract(1, 'day')
  //     .format('YYYY-MM-DD H:mm');
  // } else if (duration === '1 Week' && appliedFilter !== true) {
  //   searchFilter.createdTimeRange.begin = moment(date)
  //     .subtract(1, 'week')
  //     .format('YYYY-MM-DD H:mm');
  // } else if (duration === '15 Days' && appliedFilter !== true) {
  //   searchFilter.createdTimeRange.begin = moment(date)
  //     .subtract(15, 'days')
  //     .format('YYYY-MM-DD H:mm');
  // } else if (duration === '30 Days' && appliedFilter !== true) {
  //   searchFilter.createdTimeRange.begin = moment(date)
  //     .subtract(1, 'month')
  //     .format('YYYY-MM-DD H:mm');
  // }
  if (searchFilter?.createdTimeRange?.begin) {
    const startDate = searchFilter.createdTimeRange.begin;
    filterDates.startDate = getUTCDate(startDate, state);
    // setStartDate(filterDates.startDate);
  }

  if (searchFilter?.createdTimeRange?.end) {
    const endDate = searchFilter.createdTimeRange.end;
    filterDates.endDate = getUTCDate(endDate, state);
    // setEndDate(filterDates.endDate);
  } else {
    if (selectedKey === 'EVENTS' && workflowCode === 'freightTracking') {
      let endDate = moment(filterDates.startDate)
        .subtract(0.5, 'h')
        .format(date_format);

      filterDates.endDate = filterDates.startDate;
      filterDates.startDate = endDate;
    } else {
      filterDates.endDate = null;
    }
  }

  filterFields &&
    filterFields.map((field: any) => {
      if (isPresent(field)) {
        let value = '';
        Object.keys(mapSearchFields).map((k, i) => {
          if (k === field) {
            value = Object.values(mapSearchFields)[i];
            search[value] = toColonSperated(field);
          }
        });
      }
    });

  if (searchFilter?.retryStatus?.retryStatus) {
    search.retryStatus = searchFilter?.retryStatus?.retryStatus;
  }

  if (searchFilter?.initialResponseHttpStatus?.fromErrorCode || searchFilter?.initialResponseHttpStatus?.toErrorCode) {
    search.initialResponseHttpStatus = searchFilter?.initialResponseHttpStatus;
  }

  if (searchFilter?.service?.service) {
    let serviceArray = searchFilter?.service?.service;
    search.service = serviceArray.join(':');
  }
  if (searchFilter?.customerAggregator?.length > 0) {
    search.customerAggregator = searchFilter?.customerAggregator.join(':');
  }
  let joinOperator: any = ',';
  if (workflowCode === 'freightTracking') {
    joinOperator = ';';
  }

  search = Object.keys(search)
    .map(key => {
      if (key === 'apiResponseTime') {
        return key + responseTimeData[1].value + search[key];
      } else if (key === 'initialResponseHttpStatus') {
        return `${key}!${search[key]?.fromErrorCode}:${search[key]?.toErrorCode}`;
      } else if (key === 'retryCount' || key === 'timeTaken') {
        return `${key}${search[key]?.symbol}${search[key]?.value}`;
      } else {
        return key + '=' + search[key];
      }
    })
    .join(joinOperator);

  const [getErrors, { loading, data, networkStatus, refetch }] = useLazyQuery(ERROR_DIAGNOSIS_QUERY, {
    onError: () => {
      enqueueSnackbar('Fetching Events Failed', { variant: 'error', preventDuplicate: true });
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });

  const [getFreightErrors, { loading: freightLoading, data: freightData, refetch: freightRefetch }] = useLazyQuery(
    ERROR_DIAGNOSIS_QUERY_FREIGHT_TRACKING,
    {
      onError: () => {
        enqueueSnackbar('Fetching Freight Errors Failed', { variant: 'error', preventDuplicate: true });
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    }
  );

  const [
    getFreightEvents,
    { loading: freightEventLoading, data: freightEventData, networkStatus: freightNetworkStatus }
  ] = useLazyQuery(ERROR_DIAGNOSIS_QUERY_FT_EVENTS, {
    onError: () => {
      enqueueSnackbar('Fetching Freight Events Failed', { variant: 'error', preventDuplicate: true });
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });

  const [getAuditHistory, { loading: auditHistoryLoading, data: auditData }] = useLazyQuery(AUDIT_HISTORY);

  React.useEffect(() => {
    let columns: any = [];
    let userColumn: any = [];
    const archiveColumn = getColumns(classes, 'ARCHIVE', '', state?.userPreferences?.timeZone || 'UTC');
    setArchiveColumn(archiveColumn);
    if (workflowCode) {
      userColumn = configurationData?.configurationSettings?.data?.[0]?.configuration?.columns;
      columns = getColumns(
        classes,
        props?.participant?.participantType,
        workflowCode,
        state?.userPreferences?.timeZone || 'UTC'
      );
    } else {
      userColumn = configurationData?.configurationSettings?.data?.[0]?.configuration?.columns;
      columns = props.isAdminLevel
        ? getColumns(classes, 'ADMIN', '', state?.userPreferences?.timeZone || 'UTC')
        : getColumns(classes, props?.participant?.participantType, '', state?.userPreferences?.timeZone || 'UTC');
    }
    setErrorCoulumns(columns);
  }, []);

  const handleErrorToggleChange = (e: any) => {
    handleNetworkCalls(dataType, !showErrors, workflowCode);
    isShowErrors(!showErrors);
  };

  const handleEnableFreightWorkFlow = (e: any) => {
    setEnableFreightWorkFlow(!enableFreightWorkFlow);
    let code = '';
    if (!enableFreightWorkFlow) {
      code = 'freightTracking';
    } else {
      code = '';
    }
    setWorkflowCode(code);
    handleNetworkCalls(dataType, showErrors, code);
  };

  const handleRefresh = () => {
    handleNetworkCalls(dataType, showErrors, workflowCode);
  };

  const handleDataTypeChange = (type: string) => {
    setDataType(type);
    handleNetworkCalls(type, showErrors, workflowCode);
  };

  const handleNetworkCalls = (type: any, errors: any, workFlowCode: any) => {
    let buildQuery = errors ? buildSearchErrorQuery() : buildSearchQuery();
    if (workFlowCode === 'freightTracking' && selectedKey === 'EVENTS') {
      getFreightEvents({
        variables: {
          participantCode: props?.participant?.participantCode,
          startDate: filterDates.startDate,
          endDate: filterDates.endDate,
          size: rowsPerPage,
          page: isGoTo ? gotoPageNum : pageNumber,
          search: search || ''
        }
      });
      setIsGoTo(false);
    } else if (workFlowCode === 'freightTracking' && selectedKey === 'SHIPMENTS') {
      getFreightErrors({
        variables: {
          participantCode: props?.participant?.participantCode,
          startDate: filterDates.startDate,
          endDate: filterDates.endDate,
          size: rowsPerPage,
          page: isGoTo ? gotoPageNum : pageNumber,
          search: search || ''
        }
      });
      setIsGoTo(false);
    } else if (type === 'live' && workFlowCode !== 'freightTracking') {
      getErrors({
        variables: {
          page: isGoTo ? gotoPageNum : pageNumber,
          sortOrder: sortOrder,
          sortColumn: sortColumn,
          size: rowsPerPage,
          search: buildQuery + ',' + search || '',
          ...filterDates
        }
      });
      setIsGoTo(false);
    } else if (type === 'archive') {
      getAuditHistory({
        variables: {
          search: `${buildQuery},${search}&startDate=${filterDates.startDate}&endDate=${filterDates.endDate}`
        }
      });
      setIsGoTo(false);
    }
  };

  const handleNotificationTabs = (key: any) => {
    setSelectedKey(key);
  };

  const handleColumnSelection = () => {
    setOpenColumnSelection(true);
  };

  const handleDialogClose = () => {
    setOpenColumnSelection(false);
  };

  const handleEventDetailsDialogClose = () => {
    showEventDetails(false);
  };

  const handleDialogSetSortOrder = (val: any) => {
    setSortOrder(val);
  };

  const handleViewDetails = (rowData: any) => {
    setFormData(rowData);
    showEventDetails(true);
  };

  const handleAuditDetails = (rowData: any) => {
    setAuditFormData(rowData);
    showAuditDetails(true);
  };

  const handleAuditDetailsDialogClose = () => {
    showAuditDetails(false);
  };

  const handlePageNumber = (pageNumber: any) => {
    setGotoPageNum(pageNumber);
    setIsGoTo(true);
  };

  const handleDownload = (rowData: any) => {
    setFormData(rowData);
    setDownloadJSONData(true);
  };
  const handleDownloadClose = () => {
    setDownloadJSONData(false);
  };

  const getTableColumn = () => {
    if (dataType === 'archive') return archiveColumn;
    else if (workflowCode === 'freightTracking' && selectedKey === 'EVENTS') return subcolumns;
    else if (appliedSelection && appliedColumn.length > 0) return appliedColumn;
    else if (userPrefsColumns.length > 0) return userPrefsColumns;
    else return errorColumns;
  };

  const getTableData = () => {
    if (dataType === 'archive') {
      return auditData?.auditHistory?.results;
    } else if (workflowCode === 'freightTracking' && selectedKey === 'SHIPMENTS') {
      return freightData?.errorDiagnosisFreightTracking?.content || [];
    } else if (workflowCode === 'freightTracking' && selectedKey === 'EVENTS') {
      return freightEventData?.errorDiagnosisFTEvents?.content || [];
    } else if (dataType === 'live') {
      return data?.errorDiagnosis?.content || [];
    }
  };

  const getTableCount = () => {
    if (dataType === 'archive')
      return (
        auditData?.auditHistory?.length + (auditData?.auditHistory?.continuationToken?.nextPartitionKey !== '' ? 1 : 0)
      );
    else if (workflowCode === 'freightTracking' && selectedKey === 'SHIPMENTS')
      return freightData?.errorDiagnosisFreightTracking?.totalElements;
    else if (workflowCode === 'freightTracking' && selectedKey === 'EVENTS')
      return freightEventData?.errorDiagnosisFTEvents?.totalElements;
    else return data?.errorDiagnosis?.totalElements;
  };

  let filterInfoMsg = (
    <div id="someId">
      Filter Criteria has been applied,
      <br />
      Refresh to fetch latest data
    </div>
  );

  const applyFilter = (values: any) => {
    setEnableLoader(true);
    setSearch({ ...values });
    const isDefaultCriteria: boolean = _.isEqual(
      values,
      workflowCode === 'freightTracking' ? freightDefaultFilter : defaultFilter
    );
    if (_.isEqual(values, searchFilter)) {
      enqueueSnackbar(filterInfoMsg, { variant: 'info', preventDuplicate: true });
    }
    if (!_.isEqual(values, search) && !isDefaultCriteria) {
      setAppliedFilter(true);
    } else if (isDefaultCriteria) {
      setAppliedFilter(false);
    }
    dispatch({
      type: 'userPreferences',
      data: {
        [props.id]: {
          id: props.id,
          rowsPerPage: 10,
          page: 0
        }
      }
    });
    setEnableLoader(false);
  };

  const getFilterConfig = () => {
    const operations = workflowList?.workflow?.content
      ?.map((workflow: any) => {
        const operationOptions: any = [];
        if (props.workflowCode) {
          if (props.workflowCode === workflow.workflowCode)
            workflow?.operations?.map((opr: any) => {
              const obj = { title: opr.operationName, value: opr.operationCode };
              operationOptions.push(obj);
            });
          return operationOptions;
        } else {
          workflow?.operations?.map((opr: any) => {
            const obj = { title: opr.operationName, value: opr.operationCode };
            operationOptions.push(obj);
          });
          return operationOptions;
        }
      })
      .flat();
    const participantFileds: any = {
      CUSTOMER: 'customerCodes',
      PROVIDER: 'providerCodes',
      AGGREGATOR: 'aggregator',
      CUSTOMER_AGGREGATOR: 'customerAggregator'
    };
    if (workflowCode === 'freightTracking') return freightFilterDataConfig;
    else if (dataType === 'archive')
      return archiveDataConfig?.map((field: any) => {
        if (field.id === 'operations') field['options'] = operations;
        return field;
      });
    else {
      const removeField = participantFileds[participantType];
      return filterDataConfig
        .map((field: any) => {
          if (field.id === 'operations') field['options'] = operations;
          return field;
        })
        .filter((field: any) => field.id !== removeField);
    }
  };

  const closeFilter = () => setOpenFilter(false);

  const handleApplyColumnSelection = (col: any, sortPrefs: any) => {
    setSortUserPrefs(sortPrefs);
    const columnList: any = [];
    _.forEach(col || [], (element: any) => {
      _.forEach(errorColumns || [], (obj: any) => {
        if (element.field === obj.field) {
          columnList.push(obj);
        }
      });
    });
    setAppliedColumn(columnList);
    setAppliedSelection(true);
    setOpenColumnSelection(false);
    setSortOrder(sortPrefs?.sortOrder);
    setSortColumn(sortPrefs?.sortColumn);
    setDuration(sortPrefs?.duration);
    setRowsPerPage(sortPrefs?.pageNumber);
  };

  let columns = getTableColumn();
  let displayData = getTableData();
  let tableCount = getTableCount();
  let filterConfig = getFilterConfig();

  return (
    <React.Fragment>
      <div>
        {showEventMessage && (
          <Dialog onClose={handleEventDialogClose} open={showEventMessage} maxWidth="md">
            <DialogTitle id="customized-dialog-title">Event Message</DialogTitle>
            <DialogContent dividers>
              {loading || freightEventLoading || freightNetworkStatus === NetworkStatus.refetch ? (
                <Loading />
              ) : (
                <div>
                  <Grid container style={{ width: '70vw' }}>
                    <>
                      <Grid item xs={1}></Grid>
                      <Grid item xs={5} style={{ margin: '10px' }}>
                        <Typography variant="button">{'Request'}</Typography>
                        <JsonEditor
                          setRef={setRequestEditorRef}
                          id={`jsonRequestEditor-${freightEventData?.errorDiagnosisFTEvents?.content?.id}`}
                          data={request}
                          mode={state?.userPreferences?.requestResponse || 'code'}
                        />
                      </Grid>
                    </>
                  </Grid>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleEventDialogClose} color="primary" variant="contained">
                OK
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
      <Grid container spacing={props?.isAdminLevel ? 1 : 0} direction="row">
        {userLoading ||
        loading ||
        auditHistoryLoading ||
        freightLoading ||
        freightEventLoading ||
        configurationLoading ? (
          <Loading />
        ) : (
          <>
            <ErrorDiagnosis
              columns={columns}
              data={displayData || []}
              tableCount={tableCount}
              id={props.id}
              handlePageNumber={handlePageNumber}
              page={isGoTo ? gotoPageNum : pageNumber}
              handleDataTypeChange={handleDataTypeChange}
              ErrorDiagnosisActions={ErrorDiagnosisActions}
              dataType={dataType}
              formData={formData}
              eventDetails={eventDetails}
              handleEventDetailsDialogClose={handleEventDetailsDialogClose}
              handleFilterReset={handleReset}
              filterConfig={filterConfig}
              errorColumns={errorColumns}
              closeFilter={closeFilter}
              errorCode={errorCode}
              isAdminLevel={props.isAdminLevel}
              workflowCode={workflowCode}
              participantCode={
                props?.participant?.participantCode === undefined ? 'ADMIN' : props?.participant?.participantCode
              }
              supportUser={false}
              openFilter={openFilter}
              onRowSelection={onRowSelection}
              applyFilter={applyFilter}
              searchFilter={searchFilter}
              workflowList={workflowList}
              filterDates={filterDates}
              auditDetails={auditDetails}
              auditFormData={auditFormData}
              handleAuditDetailsDialogClose={handleAuditDetailsDialogClose}
              handleDownloadClose={handleDownloadClose}
              handleDownload={handleDownload}
              downloadJSONData={downloadJSONData}
              setDownloadJSONData={setDownloadJSONData}
              participantType={participantType}
              retryStatusData={retryStatusData}
              isParticipantLevel={props.isParticipantLevel}
            />
          </>
        )}
        {configurationLoading && loading ? (
          <></>
        ) : (
          <>
            {openColumnSelection && (
              <CustomGrid
                key="custom-grid"
                data-id="custom-grid"
                title="Custom Grid"
                dialogOpen={openColumnSelection}
                handleSubmit={handleApplyColumnSelection}
                handleDialogClose={handleDialogClose}
                refresh={refetch}
                refetch={configurationRefetch}
                userSelPrefsColumns={userSelPrefsColumns}
                sortPrefs={
                  appliedSelection
                    ? sortUserPrefs
                    : props?.isAdminLevel
                    ? configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs || otherSortPrefs
                    : configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs || otherSortPrefs
                }
                defaultColumnDefs={userColumns}
                availableColumnList={
                  appliedSelection && appliedColumn.length > 0 ? appliedColumn : userColumns || errorColumns
                }
                userServiceColumns={
                  props?.isAdminLevel
                    ? configurationData?.configurationSettings?.data?.[0]?.configuration?.columns || errorColumns
                    : configurationData?.configurationSettings?.data?.[0]?.configuration?.columns || errorColumns
                }
                existingUserColumns={configurationData?.configurationSettings?.data?.[0]?.configuration?.columns}
                existingUserSortPrefs={configurationData?.configurationSettings?.data?.[0]?.configuration?.sortPrefs}
                participantType={participantType}
                workflowCode={workflowCode}
                handleDialogSetSortOrder={handleDialogSetSortOrder}
                userName={userData?.userProfile?.userName}
                isAdminLevel={props.isAdminLevel}
                supportUser={userRole !== 'APP_ADMIN' ? true : false}
              />
            )}
          </>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default ErrorDiagnosiss;
